/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { App } from '../../models/app';

export interface AppsControllerFindAll$Params {
}

export function appsControllerFindAll(http: HttpClient, rootUrl: string, params?: AppsControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<App>>> {
  const rb = new RequestBuilder(rootUrl, appsControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<App>>;
    })
  );
}

appsControllerFindAll.PATH = '/apps';
